const IP = 'nomu.strategy-offsite-meeting.com'
// const IP = "snb-nomu-be.onrender.com"


export default IP;


